export default __webpack_public_path__ + "static/media/error-page.085bfe81.png";